/**
* original author Phil Teare
* using wikipedia data
*/

export default {
    "ab": {
        "code": "AB",
        "name": "Abkhaz",
        "nativeName": "аҧсуа"
    },
    "aa": {
        "code": "AA",
        "name": "Afar",
        "nativeName": "Afaraf"
    },
    "af": {
        "code": "AF",
        "name": "Afrikaans",
        "nativeName": "Afrikaans"
    },
    "ak": {
        "code": "AK",
        "name": "Akan",
        "nativeName": "Akan"
    },
    "sq": {
        "code": "SQ",
        "name": "Albanian",
        "nativeName": "Shqip"
    },
    "am": {
        "code": "AM",
        "name": "Amharic",
        "nativeName": "አማርኛ"
    },
    "ar": {
        "code": "AR",
        "name": "Arabic",
        "nativeName": "العربية"
    },
    "an": {
        "code": "AN",
        "name": "Aragonese",
        "nativeName": "Aragonés"
    },
    "hy": {
        "code": "HY",
        "name": "Armenian",
        "nativeName": "Հայերեն"
    },
    "as": {
        "code": "AS",
        "name": "Assamese",
        "nativeName": "অসমীয়া"
    },
    "av": {
        "code": "AV",
        "name": "Avaric",
        "nativeName": "авар мацӀ, магӀарул мацӀ"
    },
    "ae": {
        "code": "AE",
        "name": "Avestan",
        "nativeName": "avesta"
    },
    "ay": {
        "code": "AY",
        "name": "Aymara",
        "nativeName": "aymar aru"
    },
    "az": {
        "code": "AZ",
        "name": "Azerbaijani",
        "nativeName": "azərbaycan dili"
    },
    "bm": {
        "code": "BM",
        "name": "Bambara",
        "nativeName": "bamanankan"
    },
    "ba": {
        "code": "BA",
        "name": "Bashkir",
        "nativeName": "башҡорт теле"
    },
    "eu": {
        "code": "EU",
        "name": "Basque",
        "nativeName": "euskara, euskera"
    },
    "be": {
        "code": "BE",
        "name": "Belarusian",
        "nativeName": "Беларуская"
    },
    "bn": {
        "code": "BN",
        "name": "Bengali",
        "nativeName": "বাংলা"
    },
    "bh": {
        "code": "BH",
        "name": "Bihari",
        "nativeName": "भोजपुरी"
    },
    "bi": {
        "code": "BI",
        "name": "Bislama",
        "nativeName": "Bislama"
    },
    "bs": {
        "code": "BS",
        "name": "Bosnian",
        "nativeName": "bosanski jezik"
    },
    "br": {
        "code": "BR",
        "name": "Breton",
        "nativeName": "brezhoneg"
    },
    "bg": {
        "code": "BG",
        "name": "Bulgarian",
        "nativeName": "български език"
    },
    "my": {
        "code": "MY",
        "name": "Burmese",
        "nativeName": "ဗမာစာ"
    },
    "ca": {
        "code": "CA",
        "name": "Catalan; Valencian",
        "nativeName": "Català"
    },
    "ch": {
        "code": "CH",
        "name": "Chamorro",
        "nativeName": "Chamoru"
    },
    "ce": {
        "code": "CE",
        "name": "Chechen",
        "nativeName": "нохчийн мотт"
    },
    "ny": {
        "code": "NY",
        "name": "Chichewa; Chewa; Nyanja",
        "nativeName": "chiCheŵa, chinyanja"
    },
    "zh": {
        "code": "ZH",
        "name": "Chinese",
        "nativeName": "中文 (Zhōngwén), 汉语, 漢語"
    },
    "cv": {
        "code": "CV",
        "name": "Chuvash",
        "nativeName": "чӑваш чӗлхи"
    },
    "kw": {
        "code": "KW",
        "name": "Cornish",
        "nativeName": "Kernewek"
    },
    "co": {
        "code": "CO",
        "name": "Corsican",
        "nativeName": "corsu, lingua corsa"
    },
    "cr": {
        "code": "CR",
        "name": "Cree",
        "nativeName": "ᓀᐦᐃᔭᐍᐏᐣ"
    },
    "hr": {
        "code": "HR",
        "name": "Croatian",
        "nativeName": "hrvatski"
    },
    "cs": {
        "code": "CS",
        "name": "Czech",
        "nativeName": "česky, čeština"
    },
    "da": {
        "code": "DA",
        "name": "Danish",
        "nativeName": "dansk"
    },
    "dv": {
        "code": "DV",
        "name": "Divehi; Dhivehi; Maldivian;",
        "nativeName": "ދިވެހި"
    },
    "nl": {
        "code": "NL",
        "name": "Dutch",
        "nativeName": "Nederlands, Vlaams"
    },
    "en": {
        "code": "EN",
        "name": "English",
        "nativeName": "English"
    },
    "eo": {
        "code": "EO",
        "name": "Esperanto",
        "nativeName": "Esperanto"
    },
    "et": {
        "code": "ET",
        "name": "Estonian",
        "nativeName": "eesti, eesti keel"
    },
    "ee": {
        "code": "EE",
        "name": "Ewe",
        "nativeName": "Eʋegbe"
    },
    "fo": {
        "code": "FO",
        "name": "Faroese",
        "nativeName": "føroyskt"
    },
    "fj": {
        "code": "FJ",
        "name": "Fijian",
        "nativeName": "vosa Vakaviti"
    },
    "fi": {
        "code": "FI",
        "name": "Finnish",
        "nativeName": "suomi, suomen kieli"
    },
    "fr": {
        "code": "FR",
        "name": "French",
        "nativeName": "français, langue française"
    },
    "ff": {
        "code": "FF",
        "name": "Fula; Fulah; Pulaar; Pular",
        "nativeName": "Fulfulde, Pulaar, Pular"
    },
    "gl": {
        "code": "GL",
        "name": "Galician",
        "nativeName": "Galego"
    },
    "ka": {
        "code": "KA",
        "name": "Georgian",
        "nativeName": "ქართული"
    },
    "de": {
        "code": "DE",
        "name": "German",
        "nativeName": "Deutsch"
    },
    "el": {
        "code": "EL",
        "name": "Greek, Modern",
        "nativeName": "Ελληνικά"
    },
    "gn": {
        "code": "GN",
        "name": "Guaraní",
        "nativeName": "Avañeẽ"
    },
    "gu": {
        "code": "GU",
        "name": "Gujarati",
        "nativeName": "ગુજરાતી"
    },
    "ht": {
        "code": "HT",
        "name": "Haitian; Haitian Creole",
        "nativeName": "Kreyòl ayisyen"
    },
    "ha": {
        "code": "HA",
        "name": "Hausa",
        "nativeName": "Hausa, هَوُسَ"
    },
    "he": {
        "code": "HE",
        "name": "Hebrew (modern)",
        "nativeName": "עברית"
    },
    "hz": {
        "code": "HZ",
        "name": "Herero",
        "nativeName": "Otjiherero"
    },
    "hi": {
        "code": "HI",
        "name": "Hindi",
        "nativeName": "हिन्दी, हिंदी"
    },
    "ho": {
        "code": "HO",
        "name": "Hiri Motu",
        "nativeName": "Hiri Motu"
    },
    "hu": {
        "code": "HU",
        "name": "Hungarian",
        "nativeName": "Magyar"
    },
    "ia": {
        "code": "IA",
        "name": "Interlingua",
        "nativeName": "Interlingua"
    },
    "id": {
        "code": "ID",
        "name": "Indonesian",
        "nativeName": "Bahasa Indonesia"
    },
    "ie": {
        "code": "IE",
        "name": "Interlingue",
        "nativeName": "Originally called Occidental; then Interlingue after WWII"
    },
    "ga": {
        "code": "GA",
        "name": "Irish",
        "nativeName": "Gaeilge"
    },
    "ig": {
        "code": "IG",
        "name": "Igbo",
        "nativeName": "Asụsụ Igbo"
    },
    "ik": {
        "code": "IK",
        "name": "Inupiaq",
        "nativeName": "Iñupiaq, Iñupiatun"
    },
    "io": {
        "code": "IO",
        "name": "Ido",
        "nativeName": "Ido"
    },
    "is": {
        "code": "IS",
        "name": "Icelandic",
        "nativeName": "Íslenska"
    },
    "it": {
        "code": "IT",
        "name": "Italian",
        "nativeName": "Italiano"
    },
    "iu": {
        "code": "IU",
        "name": "Inuktitut",
        "nativeName": "ᐃᓄᒃᑎᑐᑦ"
    },
    "ja": {
        "code": "JA",
        "name": "Japanese",
        "nativeName": "日本語 (にほんご／にっぽんご)"
    },
    "jv": {
        "code": "JV",
        "name": "Javanese",
        "nativeName": "basa Jawa"
    },
    "kl": {
        "code": "KL",
        "name": "Kalaallisut, Greenlandic",
        "nativeName": "kalaallisut, kalaallit oqaasii"
    },
    "kn": {
        "code": "KN",
        "name": "Kannada",
        "nativeName": "ಕನ್ನಡ"
    },
    "kr": {
        "code": "KR",
        "name": "Kanuri",
        "nativeName": "Kanuri"
    },
    "ks": {
        "code": "KS",
        "name": "Kashmiri",
        "nativeName": "कश्मीरी, كشميري‎"
    },
    "kk": {
        "code": "KK",
        "name": "Kazakh",
        "nativeName": "Қазақ тілі"
    },
    "km": {
        "code": "KM",
        "name": "Khmer",
        "nativeName": "ភាសាខ្មែរ"
    },
    "ki": {
        "code": "KI",
        "name": "Kikuyu, Gikuyu",
        "nativeName": "Gĩkũyũ"
    },
    "rw": {
        "code": "RW",
        "name": "Kinyarwanda",
        "nativeName": "Ikinyarwanda"
    },
    "ky": {
        "code": "KY",
        "name": "Kirghiz, Kyrgyz",
        "nativeName": "кыргыз тили"
    },
    "kv": {
        "code": "KV",
        "name": "Komi",
        "nativeName": "коми кыв"
    },
    "kg": {
        "code": "KG",
        "name": "Kongo",
        "nativeName": "KiKongo"
    },
    "ko": {
        "code": "KO",
        "name": "Korean",
        "nativeName": "한국어 (韓國語), 조선말 (朝鮮語)"
    },
    "ku": {
        "code": "KU",
        "name": "Kurdish",
        "nativeName": "Kurdî, كوردی‎"
    },
    "kj": {
        "code": "KJ",
        "name": "Kwanyama, Kuanyama",
        "nativeName": "Kuanyama"
    },
    "la": {
        "code": "LA",
        "name": "Latin",
        "nativeName": "latine, lingua latina"
    },
    "lb": {
        "code": "LB",
        "name": "Luxembourgish, Letzeburgesch",
        "nativeName": "Lëtzebuergesch"
    },
    "lg": {
        "code": "LG",
        "name": "Luganda",
        "nativeName": "Luganda"
    },
    "li": {
        "code": "LI",
        "name": "Limburgish, Limburgan, Limburger",
        "nativeName": "Limburgs"
    },
    "ln": {
        "code": "LN",
        "name": "Lingala",
        "nativeName": "Lingála"
    },
    "lo": {
        "code": "LO",
        "name": "Lao",
        "nativeName": "ພາສາລາວ"
    },
    "lt": {
        "code": "LT",
        "name": "Lithuanian",
        "nativeName": "lietuvių kalba"
    },
    "lu": {
        "code": "LU",
        "name": "Luba-Katanga",
        "nativeName": ""
    },
    "lv": {
        "code": "LV",
        "name": "Latvian",
        "nativeName": "latviešu valoda"
    },
    "gv": {
        "code": "GV",
        "name": "Manx",
        "nativeName": "Gaelg, Gailck"
    },
    "mk": {
        "code": "MK",
        "name": "Macedonian",
        "nativeName": "македонски јазик"
    },
    "mg": {
        "code": "MG",
        "name": "Malagasy",
        "nativeName": "Malagasy fiteny"
    },
    "ms": {
        "code": "MS",
        "name": "Malay",
        "nativeName": "bahasa Melayu, بهاس ملايو‎"
    },
    "ml": {
        "code": "ML",
        "name": "Malayalam",
        "nativeName": "മലയാളം"
    },
    "mt": {
        "code": "MT",
        "name": "Maltese",
        "nativeName": "Malti"
    },
    "mi": {
        "code": "MI",
        "name": "Māori",
        "nativeName": "te reo Māori"
    },
    "mr": {
        "code": "MR",
        "name": "Marathi (Marāṭhī)",
        "nativeName": "मराठी"
    },
    "mh": {
        "code": "MH",
        "name": "Marshallese",
        "nativeName": "Kajin M̧ajeļ"
    },
    "mn": {
        "code": "MN",
        "name": "Mongolian",
        "nativeName": "монгол"
    },
    "na": {
        "code": "NA",
        "name": "Nauru",
        "nativeName": "Ekakairũ Naoero"
    },
    "nv": {
        "code": "NV",
        "name": "Navajo, Navaho",
        "nativeName": "Diné bizaad, Dinékʼehǰí"
    },
    "nb": {
        "code": "NB",
        "name": "Norwegian Bokmål",
        "nativeName": "Norsk bokmål"
    },
    "nd": {
        "code": "ND",
        "name": "North Ndebele",
        "nativeName": "isiNdebele"
    },
    "ne": {
        "code": "NE",
        "name": "Nepali",
        "nativeName": "नेपाली"
    },
    "ng": {
        "code": "NG",
        "name": "Ndonga",
        "nativeName": "Owambo"
    },
    "nn": {
        "code": "NN",
        "name": "Norwegian Nynorsk",
        "nativeName": "Norsk nynorsk"
    },
    "no": {
        "code": "NO",
        "name": "Norwegian",
        "nativeName": "Norsk"
    },
    "ii": {
        "code": "II",
        "name": "Nuosu",
        "nativeName": "ꆈꌠ꒿ Nuosuhxop"
    },
    "nr": {
        "code": "NR",
        "name": "South Ndebele",
        "nativeName": "isiNdebele"
    },
    "oc": {
        "code": "OC",
        "name": "Occitan",
        "nativeName": "Occitan"
    },
    "oj": {
        "code": "OJ",
        "name": "Ojibwe, Ojibwa",
        "nativeName": "ᐊᓂᔑᓈᐯᒧᐎᓐ"
    },
    "cu": {
        "code": "CU",
        "name": "Old Church Slavonic, Church Slavic, Church Slavonic, Old Bulgarian, Old Slavonic",
        "nativeName": "ѩзыкъ словѣньскъ"
    },
    "om": {
        "code": "OM",
        "name": "Oromo",
        "nativeName": "Afaan Oromoo"
    },
    "or": {
        "code": "OR",
        "name": "Oriya",
        "nativeName": "ଓଡ଼ିଆ"
    },
    "os": {
        "code": "OS",
        "name": "Ossetian, Ossetic",
        "nativeName": "ирон æвзаг"
    },
    "pa": {
        "code": "PA",
        "name": "Panjabi, Punjabi",
        "nativeName": "ਪੰਜਾਬੀ, پنجابی‎"
    },
    "pi": {
        "code": "PI",
        "name": "Pāli",
        "nativeName": "पाऴि"
    },
    "fa": {
        "code": "FA",
        "name": "Persian",
        "nativeName": "فارسی"
    },
    "pl": {
        "code": "PL",
        "name": "Polish",
        "nativeName": "polski"
    },
    "ps": {
        "code": "PS",
        "name": "Pashto, Pushto",
        "nativeName": "پښتو"
    },
    "pt": {
        "code": "PT",
        "name": "Portuguese",
        "nativeName": "Português"
    },
    "qu": {
        "code": "QU",
        "name": "Quechua",
        "nativeName": "Runa Simi, Kichwa"
    },
    "rm": {
        "code": "RM",
        "name": "Romansh",
        "nativeName": "rumantsch grischun"
    },
    "rn": {
        "code": "RN",
        "name": "Kirundi",
        "nativeName": "kiRundi"
    },
    "ro": {
        "code": "RO",
        "name": "Romanian, Moldavian, Moldovan",
        "nativeName": "română"
    },
    "ru": {
        "code": "RU",
        "name": "Russian",
        "nativeName": "русский язык"
    },
    "sa": {
        "code": "SA",
        "name": "Sanskrit (Saṁskṛta)",
        "nativeName": "संस्कृतम्"
    },
    "sc": {
        "code": "SC",
        "name": "Sardinian",
        "nativeName": "sardu"
    },
    "sd": {
        "code": "SD",
        "name": "Sindhi",
        "nativeName": "सिन्धी, سنڌي، سندھی‎"
    },
    "se": {
        "code": "SE",
        "name": "Northern Sami",
        "nativeName": "Davvisámegiella"
    },
    "sm": {
        "code": "SM",
        "name": "Samoan",
        "nativeName": "gagana faa Samoa"
    },
    "sg": {
        "code": "SG",
        "name": "Sango",
        "nativeName": "yângâ tî sängö"
    },
    "sr": {
        "code": "SR",
        "name": "Serbian",
        "nativeName": "српски језик"
    },
    "gd": {
        "code": "GD",
        "name": "Scottish Gaelic; Gaelic",
        "nativeName": "Gàidhlig"
    },
    "sn": {
        "code": "SN",
        "name": "Shona",
        "nativeName": "chiShona"
    },
    "si": {
        "code": "SI",
        "name": "Sinhala, Sinhalese",
        "nativeName": "සිංහල"
    },
    "sk": {
        "code": "SK",
        "name": "Slovak",
        "nativeName": "slovenčina"
    },
    "sl": {
        "code": "SL",
        "name": "Slovene",
        "nativeName": "slovenščina"
    },
    "so": {
        "code": "SO",
        "name": "Somali",
        "nativeName": "Soomaaliga, af Soomaali"
    },
    "st": {
        "code": "ST",
        "name": "Southern Sotho",
        "nativeName": "Sesotho"
    },
    "es": {
        "code": "ES",
        "name": "Spanish; Castilian",
        "nativeName": "español, castellano"
    },
    "su": {
        "code": "SU",
        "name": "Sundanese",
        "nativeName": "Basa Sunda"
    },
    "sw": {
        "code": "SW",
        "name": "Swahili",
        "nativeName": "Kiswahili"
    },
    "ss": {
        "code": "SS",
        "name": "Swati",
        "nativeName": "SiSwati"
    },
    "sv": {
        "code": "SV",
        "name": "Swedish",
        "nativeName": "svenska"
    },
    "ta": {
        "code": "TA",
        "name": "Tamil",
        "nativeName": "தமிழ்"
    },
    "te": {
        "code": "TE",
        "name": "Telugu",
        "nativeName": "తెలుగు"
    },
    "tg": {
        "code": "TG",
        "name": "Tajik",
        "nativeName": "тоҷикӣ, toğikī, تاجیکی‎"
    },
    "th": {
        "code": "TH",
        "name": "Thai",
        "nativeName": "ไทย"
    },
    "ti": {
        "code": "TI",
        "name": "Tigrinya",
        "nativeName": "ትግርኛ"
    },
    "bo": {
        "code": "BO",
        "name": "Tibetan Standard, Tibetan, Central",
        "nativeName": "བོད་ཡིག"
    },
    "tk": {
        "code": "TK",
        "name": "Turkmen",
        "nativeName": "Türkmen, Түркмен"
    },
    "tl": {
        "code": "TL",
        "name": "Tagalog",
        "nativeName": "Wikang Tagalog, ᜏᜒᜃᜅ᜔ ᜆᜄᜎᜓᜄ᜔"
    },
    "tn": {
        "code": "TN",
        "name": "Tswana",
        "nativeName": "Setswana"
    },
    "to": {
        "code": "TO",
        "name": "Tonga (Tonga Islands)",
        "nativeName": "faka Tonga"
    },
    "tr": {
        "code": "TR",
        "name": "Turkish",
        "nativeName": "Türkçe"
    },
    "ts": {
        "code": "TS",
        "name": "Tsonga",
        "nativeName": "Xitsonga"
    },
    "tt": {
        "code": "TT",
        "name": "Tatar",
        "nativeName": "татарча, tatarça, تاتارچا‎"
    },
    "tw": {
        "code": "TW",
        "name": "Twi",
        "nativeName": "Twi"
    },
    "ty": {
        "code": "TY",
        "name": "Tahitian",
        "nativeName": "Reo Tahiti"
    },
    "ug": {
        "code": "UG",
        "name": "Uighur, Uyghur",
        "nativeName": "Uyƣurqə, ئۇيغۇرچە‎"
    },
    "uk": {
        "code": "UK",
        "name": "Ukrainian",
        "nativeName": "українська"
    },
    "ur": {
        "code": "UR",
        "name": "Urdu",
        "nativeName": "اردو"
    },
    "uz": {
        "code": "UZ",
        "name": "Uzbek",
        "nativeName": "zbek, Ўзбек, أۇزبېك‎"
    },
    "ve": {
        "code": "VE",
        "name": "Venda",
        "nativeName": "Tshivenḓa"
    },
    "vi": {
        "code": "VI",
        "name": "Vietnamese",
        "nativeName": "Tiếng Việt"
    },
    "vo": {
        "code": "VO",
        "name": "Volapük",
        "nativeName": "Volapük"
    },
    "wa": {
        "code": "WA",
        "name": "Walloon",
        "nativeName": "Walon"
    },
    "cy": {
        "code": "CY",
        "name": "Welsh",
        "nativeName": "Cymraeg"
    },
    "wo": {
        "code": "WO",
        "name": "Wolof",
        "nativeName": "Wollof"
    },
    "fy": {
        "code": "FY",
        "name": "Western Frisian",
        "nativeName": "Frysk"
    },
    "xh": {
        "code": "XH",
        "name": "Xhosa",
        "nativeName": "isiXhosa"
    },
    "yi": {
        "code": "YI",
        "name": "Yiddish",
        "nativeName": "ייִדיש"
    },
    "yo": {
        "code": "YO",
        "name": "Yoruba",
        "nativeName": "Yorùbá"
    },
    "za": {
        "code": "ZA",
        "name": "Zhuang, Chuang",
        "nativeName": "Saɯ cueŋƅ, Saw cuengh"
    }
}



// WEBPACK FOOTER //
// ./src/static/languages.js